import * as types from './actionTypes';  
import connectedCustomersApi from '../api/connectedCustomersApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doConnectedCustomers(request) {

  return {
    type: types.DO_CONNECTED_CUSTOMERS,
    request
  };
}

export function doConnectedCustomersRes(data) {  
  return {
    type: types.DO_CONNECTED_CUSTOMERS_RES, 
    data
  };
}

export function getConnectedCustomers(request) {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      connectedCustomersApi.doConnectedCustomers(request).then(data => {
        dispatch(doConnectedCustomersRes(data));
        dispatch(doConnectedCustomersRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
}

